import React, { useEffect, useState, useRef } from "react";
import { Dimensions, Text, TouchableOpacity, View } from "react-native";
import Header from "../../common/Header";
import * as RootNavigation from "../../utilities/RootNavigation"
import CImage from "../../common/CImage";
import CustomButton from "../../common/CustomButton";
import applicationStyles from "../../styles/applicationStyles";
import CustomTextInput from "../../common/CustomTextInput";
import CustomInput from "../../common/CustomInput";
import LoginFooter from "./LoginFooter";
import LoginRightWidget from "./LoginRightWidget";
import LoginTabIcons from "./LoginTabIcons";
import LoginMoibleContent from "./LoginMobileContent";
import {sendOtp,validateLoginVrnOTP,validateOtp} from "../../api/apiManager";
import { decrypt} from "../../utilities/Encryption";
import AsyncStorageFunc from '../../utilities/asyncStorage'
import { useLogin } from '../../context/loginProvider';
import { useLocation } from "react-router-dom";
import CountdownTimer from "../../common/CTimer.web";
import useStyles from "./LoginByVrnScreen_Styles";

export default function LoginByVrnScreen(props) {
  const{state} = useLocation()
  const keepMeSignIn = state?.data?.keepMeSignIn || "N";
  const type = state?.type || "LoginByVRN";
  const mobileNo = state?.mobile || "";
  const otpPattern = /^\d{6}$/
  const styles = useStyles();
  const time = new Date();
  time.setSeconds(time.getSeconds() + 600);
  const [vehicleNo, setVehicleNo] = useState("");
  const [otp, setOtp] = useState("");
  const [otpResponse, setOtpResponse] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [screenName, setScreenName] = useState("1");
  const counterRef = useRef(null);
  const { isLoggedIn, setIsLoggedIn } = useLogin();
  const [errormsg,setErrorMessage] = useState("")
  const onSendOtp = (reqObj) => {
    sendOtp(reqObj).then((res) => {
        setIsLoading(false);
        if (res?.data?.statusCode == 1003) {
          setScreenName("2");
          setOtpResponse(res?.data);
        } else if (res?.data?.statusCode <0  || res?.data?.statusCode == 500) {  
          const routeObj = {
            title: "Login By Vrn",
            type: "Error",
            msg: res?.data?.message,
            btnText: "Ok",
            navigation: "Login",
          };
          RootNavigation.navigate("ResponseScreen", {data: routeObj,vrnFromLogin: vehicleNo,});
        }
      })
      .catch((err) => {
        setIsLoading(false);
        const routeObj = {
          title: "Login",
          type: "Error",
          msg: err?.response?.data?.message,
          btnText: "Ok",
          navigation: "Login",
        };
        RootNavigation.navigate("ResponseScreen", {data: routeObj, vrnFromLogin: vehicleNo, });
      });
  };

  const onClickGetOtp = () => {
    setErrorMessage("")
    let reqObj = {
      type: type == "forgotPassword" ? "forgotPasswordByVrn" : "LoginByVRN",
      vrn: vehicleNo,};
    onSendOtp(reqObj)
  };
  const otpValidate = () => {
      setErrorMessage("")
      type == "forgotPassword" ? onValidateOtp() : onValidateLoginVrnOtp()
      setOtp("")
  };

  const onValidateOtp = () => {
    setIsLoading(true)
    let reqObj = {
      type: "forgotPasswordByVrn",
      otp: otp,
      requestId: otpResponse?.response?.otp,
    };
    validateOtp(reqObj).then(async res=>{
      setIsLoading(false)
      if (res?.data?.statusCode == 1008) {
        RootNavigation.navigate("ForgotPasswordScreen",{screenName:3,reqId:otpResponse?.response?.otp,mobileNo:res?.data?.data?.userId})
        
      }else if(res?.data?.statusCode < 0){
        const routeObj = {
          title:"Forgot Password",
          type : "Error",
          msg: res?.data?.message,
          btnText :"Ok",
          navigation : "SelectForgotScreen",
      }
      RootNavigation.navigate("ResponseScreen",{ data : routeObj, vrnFromLogin: vehicleNo  })
      }
    }).catch(err=>{
      const errData = err?.response?.data
      if(errData?.message == "Invalid OTP"){
        setErrorMessage(errData.message)
      }
      
    })
  };

  const onValidateLoginVrnOtp = () => {
    setIsLoading(true)
    let reqObj = {
      type: "LoginByVRN",
      otp: otp,
      requestId: otpResponse?.response?.otp,
      vrn: vehicleNo,
      keepMeSignIn :keepMeSignIn
    };
    validateLoginVrnOTP(reqObj).then(async res=>{
      setIsLoading(false)
      if (res?.status == 200) {
        if(res?.data?.access_token){
          const loginData = await decrypt(res?.data?.access_token)
          AsyncStorageFunc.storeData('TOKEN', res?.data?.access_token)
          global.token = res?.data?.access_token;
                        global.userId = loginData.userId;
                        global.userCd = loginData.userCd;
                        global.fullName = loginData.fullName ? loginData.fullName : "";
                        global.userType = loginData.userType;
                        setIsLoggedIn(true)
                        let route = global?.prevRoute || "/Home"
                        route = route.slice(1) 
                        RootNavigation.navigate(route, { showConfig: "showConfig" });
                        global.activeScreen = route

                        global.showConfig = true
        }
      }else if(res?.data?.statusCode < 0){
        const routeObj = {
          title:"Activate User Id",
          type : "Error",
          msg: res?.data?.message,
          btnText :"Ok",
          navigation : "SelectForgotScreen",
      }
      RootNavigation.navigate("ResponseScreen",{ data : routeObj, vrnFromLogin: vehicleNo  })
      }
    }).catch(err=>{
      const errData = err?.response?.data
      if(errData?.message == "Invalid OTP"){
        setErrorMessage(errData.message)
      }else{
        let isForceLogin = false;
        let route = global?.prevRoute || "/Home"
              route = route.slice(1) 
        if( errData?.message == "You are already logged in to another device. Do you want to continue here")isForceLogin = true
        const routeObj = {
          username :props?.route?.params?.userId,
          loginType :"LoginByVRN",
          title:"Login",
          type : "Error",
          msg: errData?.message,
          btnText :isForceLogin ? "Continue":"Back To Login",
          navigation : isForceLogin ? route : "Login",
          isForceLogin : isForceLogin,
          keepMeSignIn :keepMeSignIn
      }
      RootNavigation.navigate("ResponseScreen",{ data : routeObj,vrnFromLogin: vehicleNo  })
      }
    })
  };

  const renderLooginByVrn = () =>{
    return  <View style={styles.containerBox}>
    <View style={styles.rectangle41}>
      <TouchableOpacity onPress={() => RootNavigation.navigate("Login")}>
        <CImage.BackIconWhite></CImage.BackIconWhite>
      </TouchableOpacity>
      <Text style={[applicationStyles.loginTextStyle]}>
        { type == "forgotPassword" ? "Forgot Password" : "Customer Login"}
        {}
      </Text>
    </View>
    {
      screenName == "1" ? (
        <View style={styles.cntWidget}>
          <Text style={[applicationStyles.enterOtpDescStyle,{lineHeight:18}]}>
            {"Multiple accounts are linked to this number. Please enter your vehicle registration number"}
          </Text>
          <Text style={styles.labelStyle}>{"RC/Vehicle/Chassis Number"}</Text>
          <CustomTextInput value={vehicleNo} onChangeText={setVehicleNo} maxLength={20}  style={styles.textInputVrn} />
          <View  style={styles.getOtpBtn}>
            <CustomButton
              onPress={!vehicleNo ? null : onClickGetOtp}
              text={"Get OTP"}
              disable={!vehicleNo}
            />
          </View>
        </View>
      ) : screenName == "2" ? (
        <View style={{ width: "80%", alignSelf: "center" }}>
          <Text style={[applicationStyles.enterOtpDescStyle,{lineHeight:18}]}>
          {otpResponse?.message}
          </Text>
          <Text style={applicationStyles.enterOtpTxtStyle}>
            {"Enter OTP"}
          </Text>

          <CustomInput
            value={otp}
            onValueChanged={(e) => {setOtp(e),setErrorMessage("")}}
            style={[styles.textInputStyle, { width: 280 }]}
            maxLength={6}
            pattern={/^\d{6}$/}
            errorMessage={"Enter Valid OTP"}
            type="number"
            keyboardType="numeric"
          />
          <Text style = {{color : "red"}}>{errormsg}</Text> 
          <View style={styles.resendViewStyle}>
            <CountdownTimer
            requestOtp={screenName == "2"}
            onClickGetOtp={onClickGetOtp}
            counterRef={counterRef}
            />
       
          </View>
          <View style={styles.nextBtnWidget} >
            <CustomButton
              text={"Next"}
              onPress={!otpPattern.test(otp) ? null : otpValidate}
              disable={!otpPattern.test(otp) ? true : false}
            />
          </View>
        </View>
      ) : (
        ""
      )
    }
  </View>
  }


  return (
    <View style={styles.mainContainerStyle}>
      <View style={{ flex: 1 }}>
        <Header text={"Login"} />
        <View style={styles.bodyContainerStyle}>
          <View style={styles.bodyLeftViewStyle}>
            {renderLooginByVrn()}
            <LoginTabIcons />
          </View>
          <LoginRightWidget />
        </View>
        <View style={styles.mobileComponentStyle}>
          <View style={styles.mobileContentWrapper}>
            <View style={{ flexDirection: "row" }}>
              <CImage.IDFCLogo></CImage.IDFCLogo>
            </View>
            <View>
              <CImage.FFLogoSmall></CImage.FFLogoSmall>
            </View>
          </View>
          <View style={styles.mobileContentWidget} >
          {renderLooginByVrn()}
          </View>
          <LoginMoibleContent />
        </View>
        <LoginFooter />
      </View>
    </View>
  );
}


